import { EmployeesList } from '../../../features/employees/EmployeesList';
import {
  compose,
  withAuthorized,
  withBaseLayout,
  withHelmet
} from '../../../core';

export const EmployeesListPage = compose(
  withAuthorized,
  withBaseLayout,
  withHelmet({
    title: 'Splashworks: Employees'
  })
)(EmployeesList);
